import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { GoogleMapsService } from './google-maps-service.service';

export const googlemapsInitializerResolver: ResolveFn<boolean> = (route, state) => {
  const googleMapsService = inject(GoogleMapsService);
  return googleMapsService.loadGoogleMaps().pipe(
    map(() => true),
    catchError(error => {
      console.error('Error during google maps initialization: ', error);
      return of(false);
    }),
  );
};
